import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { MenuPageDesignation } from "@biteinc/enums";
//#region src/utils/menu_structure_utils.ts
var menu_structure_utils_exports = /* @__PURE__ */ __exportAll({
	getAllMenuSectionIds: () => getAllMenuSectionIds,
	isEmpty: () => isEmpty,
	removeEmptyPages: () => removeEmptyPages
});
function removeEmptyPages(data, sectionIdSet) {
	removeEmptyPagesFromPage(data, sectionIdSet);
}
function removeEmptyPagesFromPage(page, sectionIdSet) {
	if (!page.pages?.length) return;
	for (let i = page.pages.length - 1; i >= 0; i--) {
		const subPage = page.pages[i];
		if (pageIsEmpty(subPage, sectionIdSet)) page.pages.splice(i, 1);
		else removeEmptyPagesFromPage(subPage, sectionIdSet);
	}
}
function pageIsEmpty(page, sectionIdSet) {
	if (page.designation === MenuPageDesignation.Scanner || page.designation === MenuPageDesignation.PageNav) return false;
	if (!page.pages?.length && !page.sectionIds?.length) return true;
	if (page.sectionIds?.length) {
		for (let i = page.sectionIds.length - 1; i >= 0; i--) if (!sectionIdSet[page.sectionIds[i].toString()]) page.sectionIds.splice(i, 1);
		return !page.sectionIds.length;
	}
	return (page.pages || []).every((subPage) => {
		return pageIsEmpty(subPage, sectionIdSet);
	});
}
function isEmpty(data) {
	return getAllMenuSectionIds(data).length === 0;
}
function getAllMenuSectionIds(data) {
	const sectionIds = [];
	gatherSectionIdsInMenuPage(data, sectionIds);
	return sectionIds;
}
function gatherSectionIdsInMenuPage(page, sectionIds) {
	page.sectionIds?.forEach((sectionId) => {
		sectionIds.push(sectionId);
	});
	page.pages?.forEach((subPage) => {
		gatherSectionIdsInMenuPage(subPage, sectionIds);
	});
}
//#endregion
export { getAllMenuSectionIds, isEmpty, menu_structure_utils_exports, removeEmptyPages };

//# sourceMappingURL=menu_structure_utils.js.map